import $ from 'jquery';
import Pagination from './modules/general/pagination';

/* eslint-disable no-new */
$(() => {
  new Pagination('.js-pagination');
});
/* eslint-enable no-new */
